import { Input, Label, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import ComponentCard from '../../../layouts/containers/ComponentCard';

const DatosTutoresForm = ({ formik, age, document, parentescoList, rowRef3, rowRef4 }) => {
  return (
    <>
      <ComponentCard title="Datos primer tutor" hasButton>
        <Row>
          <Col md="2">
            <Label htmlFor="nombreTutor">
              <small ref={rowRef3}>
                Nombre {age < 18 ? <span className="text-danger">*</span> : ''}
              </small>
            </Label>
            <Input
              id="nombreTutor"
              name="nombreTutor"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.nombreTutor}
              className={formik.errors.nombreTutor ? 'border border-danger error' : ''}
            />
            {formik.errors.nombreTutor ? (
              <div className="text-danger tiny">{formik.errors.nombreTutor}</div>
            ) : null}
          </Col>
          <Col md="2">
            <Label htmlFor="apellido1Tutor">
              <small>
                Primer apellido {age < 18 ? <span className="text-danger">*</span> : ''}
              </small>
            </Label>
            <Input
              id="apellido1Tutor"
              name="apellido1Tutor"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.apellido1Tutor}
              className={formik.errors.apellido1Tutor ? 'border border-danger error' : ''}
            />
            {formik.errors.apellido1Tutor ? (
              <div className="text-danger tiny">{formik.errors.apellido1Tutor}</div>
            ) : null}
          </Col>
          <Col md="2">
            <Label htmlFor="apellido2Tutor">
              <small>
                Segundo apellido {age < 18 ? <span className="text-danger">*</span> : ''}
              </small>
            </Label>
            <Input
              id="apellido2Tutor"
              name="apellido2Tutor"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.apellido2Tutor}
              className={formik.errors.apellido2Tutor ? 'border border-danger error' : ''}
            />
            {formik.errors.apellido2Tutor ? (
              <div className="text-danger tiny">{formik.errors.apellido2Tutor}</div>
            ) : null}
          </Col>
          <Col md="2">
            <Label htmlFor="telefonoTutor">
              <small>Teléfono</small>
            </Label>
            <Input
              id="telefonoTutor"
              name="telefonoTutor"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.telefonoTutor}
            />
          </Col>
          <Col md="2">
            <Label htmlFor="movilTutor">
              <small>Móvil {age < 18 ? <span className="text-danger">*</span> : ''}</small>
            </Label>
            <Input
              id="movilTutor"
              name="movilTutor"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.movilTutor}
              className={formik.errors.movilTutor ? 'border border-danger error' : ''}
            />
            {formik.errors.movilTutor ? (
              <div className="text-danger tiny">{formik.errors.movilTutor}</div>
            ) : null}
          </Col>

          <Col md="2">
            <Label htmlFor="emailTutor">
              <small>Email {age < 18 ? <span className="text-danger">*</span> : ''}</small>
            </Label>
            <Input
              id="emailTutor"
              name="emailTutor"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.emailTutor}
              className={formik.errors.emailTutor ? 'border border-danger error' : ''}
            />
            {formik.errors.emailTutor ? (
              <div className="text-danger tiny">{formik.errors.emailTutor}</div>
            ) : null}
          </Col>
        </Row>
        <Row className="mt-2">
          <Col md="2">
            <Label htmlFor="tipoDocumentoTutor">
              <small>Tipo documento {age < 18 ? <span className="text-danger">*</span> : ''}</small>
            </Label>
            <Input
              id="tipoDocumentoTutor"
              name="tipoDocumentoTutor"
              type="select"
              onChange={formik.handleChange}
              value={formik.values.tipoDocumentoTutor}
              className={formik.errors.tipoDocumentoTutor ? 'border border-danger error' : ''}
            >
              {document !== ''
                ? document.map((option) => (
                    <option key={`${option.id}-tipoDocT1`} value={option.id}>
                      {option.nombre}
                    </option>
                  ))
                : ''}
            </Input>
            {formik.errors.tipoDocumentoTutor ? (
              <div className="text-danger tiny">{formik.errors.tipoDocumentoTutor}</div>
            ) : null}
          </Col>
          <Col md="2">
            <Label htmlFor="documentoTutor">
              <small>Documento {age < 18 ? <span className="text-danger">*</span> : ''}</small>
            </Label>
            <Input
              id="documentoTutor"
              name="documentoTutor"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.documentoTutor}
              className={formik.errors.documentoTutor ? 'border border-danger error' : ''}
              disabled={formik.values.tipoDocumentoTutor === '-1'}
            />
            {formik.errors.documentoTutor ? (
              <div className="text-danger tiny">{formik.errors.documentoTutor}</div>
            ) : null}
          </Col>
          <Col md="2">
            <Label htmlFor="parentescoTutor">
              <small>Parentesco {age < 18 ? <span className="text-danger">*</span> : ''}</small>
            </Label>
            <Input
              type="select"
              name="parentescoTutor"
              id="parentescoTutor"
              onChange={formik.handleChange}
              value={formik.values.parentescoTutor}
              className={formik.errors.parentescoTutor ? 'border border-danger error' : ''}
            >
              {parentescoList !== ''
                ? parentescoList.map((option) => (
                    <option key={`${option.id}-parentesco1`} value={option.id}>
                      {option.descripcion}
                    </option>
                  ))
                : ''}
            </Input>
            {formik.errors.parentescoTutor ? (
              <div className="text-danger tiny">{formik.errors.parentescoTutor}</div>
            ) : null}
          </Col>
        </Row>
      </ComponentCard>
      <ComponentCard title="Datos segundo tutor" hasButton>
        <Row>
          <Col md="2">
            <Label htmlFor="nombreTutor2">
              <small ref={rowRef4}>Nombre</small>
            </Label>
            <Input
              id="nombreTutor2"
              name="nombreTutor2"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.nombreTutor2}
              className={formik.errors.nombreTutor2 ? 'border border-danger error' : ''}
            />
            {formik.errors.nombreTutor2 ? (
              <div className="text-danger tiny">{formik.errors.nombreTutor2}</div>
            ) : null}
          </Col>
          <Col md="2">
            <Label htmlFor="apellido1Tutor2">
              <small>Primer apellido</small>
            </Label>
            <Input
              id="apellido1Tutor2"
              name="apellido1Tutor2"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.apellido1Tutor2}
              className={formik.errors.apellido1Tutor2 ? 'border border-danger error' : ''}
            />
            {formik.errors.apellido1Tutor2 ? (
              <div className="text-danger tiny">{formik.errors.apellido1Tutor2}</div>
            ) : null}
          </Col>
          <Col md="2">
            <Label htmlFor="apellido2Tutor2">
              <small>Segundo apellido</small>
            </Label>
            <Input
              id="apellido2Tutor2"
              name="apellido2Tutor2"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.apellido2Tutor2}
              className={formik.errors.apellido2Tutor2 ? 'border border-danger error' : ''}
            />
            {formik.errors.apellido2Tutor2 ? (
              <div className="text-danger tiny">{formik.errors.apellido2Tutor2}</div>
            ) : null}
          </Col>
          <Col md="2">
            <Label htmlFor="telefonoTutor2">
              <small>Teléfono</small>
            </Label>
            <Input
              id="telefonoTutor2"
              name="telefonoTutor2"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.telefonoTutor2}
              className={formik.errors.telefonoTutor2 ? 'border border-danger error' : ''}
            />
            {formik.errors.telefonoTutor2 ? (
              <div className="text-danger tiny">{formik.errors.telefonoTutor2}</div>
            ) : null}
          </Col>
          <Col md="2">
            <Label htmlFor="movilTutor2">
              <small>Móvil</small>
            </Label>
            <Input
              id="movilTutor2"
              name="movilTutor2"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.movilTutor2}
              className={formik.errors.movilTutor2 ? 'border border-danger error' : ''}
            />
            {formik.errors.movilTutor2 ? (
              <div className="text-danger tiny">{formik.errors.movilTutor2}</div>
            ) : null}
          </Col>
          <Col md="2">
            <Label htmlFor="emailTutor2">
              <small>Email</small>
            </Label>
            <Input
              id="emailTutor2"
              name="emailTutor2"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.emailTutor2}
              className={formik.errors.emailTutor2 ? 'border border-danger error' : ''}
            />
            {formik.errors.emailTutor2 ? (
              <div className="text-danger tiny">{formik.errors.emailTutor2}</div>
            ) : null}
          </Col>
        </Row>
        <Row className="mt-2">
          <Col md="2">
            <Label htmlFor="tipoDocumentoTutor2">
              <small>Tipo documento</small>
            </Label>
            <Input
              id="tipoDocumentoTutor2"
              name="tipoDocumentoTutor2"
              type="select"
              onChange={formik.handleChange}
              value={formik.values.tipoDocumentoTutor2}
              className={formik.errors.tipoDocumentoTutor2 ? 'border border-danger error' : ''}
            >
              {document !== ''
                ? document.map((option) => (
                    <option key={`${option.id}-tipoDocT2`} value={option.id}>
                      {option.nombre}
                    </option>
                  ))
                : ''}
            </Input>
            {formik.errors.tipoDocumentoTutor2 ? (
              <div className="text-danger tiny">{formik.errors.tipoDocumentoTutor2}</div>
            ) : null}
          </Col>
          <Col md="2">
            <Label htmlFor="documentoTutor2">
              <small>Documento</small>
            </Label>
            <Input
              id="documentoTutor2"
              name="documentoTutor2"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.documentoTutor2}
              className={formik.errors.documentoTutor2 ? 'border border-danger error' : ''}
              disabled={formik.values.tipoDocumentoTutor2 === '-1'}
            />
            {formik.errors.documentoTutor2 ? (
              <div className="text-danger tiny">{formik.errors.documentoTutor2}</div>
            ) : null}
          </Col>
          <Col md="2">
            <Label htmlFor="parentescoTutor2">
              <small>
                Parentesco{' '}
                {formik.values.nombreTutor2 !== '' ? <span className="text-danger">*</span> : ''}
              </small>
            </Label>
            <Input
              type="select"
              name="parentescoTutor2"
              id="parentescoTutor2"
              onChange={formik.handleChange}
              value={formik.values.parentescoTutor2}
              className={formik.errors.parentescoTutor2 ? 'border border-danger error' : ''}
            >
              {parentescoList !== ''
                ? parentescoList.map((option) => (
                    <option key={`${option.id}-parentesco2`} value={option.id}>
                      {option.descripcion}
                    </option>
                  ))
                : ''}
            </Input>
            {formik.errors.parentescoTutor2 ? (
              <div className="text-danger tiny">{formik.errors.parentescoTutor2}</div>
            ) : null}
          </Col>
        </Row>
      </ComponentCard>
    </>
  );
};

DatosTutoresForm.propTypes = {
  formik: PropTypes.object.isRequired,
  age: PropTypes.number.isRequired,
  document: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  parentescoList: PropTypes.array.isRequired,
  rowRef3: PropTypes.object.isRequired,
  rowRef4: PropTypes.object.isRequired,
};

export default DatosTutoresForm;
